package world.phantasmal.psolib

enum class Endianness {
    Little,
    Big
}
